<template>
  <!-- 是否禁用
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="是否禁用"> 
      <el-radio-group v-model="isDisable" size="small">
        <el-radio-button :label="false">否</el-radio-button>
        <el-radio-button :label="true">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 是否禁用
     *  @description 将 isDisable 字段映射到当前 isDisable 计算属性
     *  @return {Boolean}
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      isDisable: { 
        parent: i => i.baseOption,
        attr: "isDisable" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingIsDisabled.vue